module.exports = "<section class=\"row\">\n  <div class=\"event_title column\">\n    <h1 class=\"only-desktop\"><span *ngIf=\"!axeHasCommercialEvents\">Atelier : </span>{{ title }}</h1>\n  </div>\n</section>  \n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/register-event/view/event-title/event-title.component.html
// module id = ./src/app/screens/register-event/view/event-title/event-title.component.html
// module chunks = main